import Stack from "@mui/material/Stack";

import { UnderwritingQuestionsModal } from "@covertree/new-business-forms";
import {
  HomeConditions,
  HomeOptions,
} from "@covertree/new-business-uw-questions";

import { SectionCard } from "../../SectionCard";
import { useUnderwritingSection } from "./useUnderwritingSection";

export function UnderwritingSection() {
  const { isReady, viewOnly, uwContext, modalCondition, hasAnswerChanged } =
    useUnderwritingSection();

  return (
    <SectionCard title="Underwriting" dataTestId="underwriting-section">
      {isReady && (
        <Stack
          component="fieldset"
          disabled={viewOnly}
          spacing={4}
          sx={{
            border: 0,
            m: 0,
            p: 0,
            minWidth: 0,
            pointerEvents: viewOnly ? "none" : undefined,
          }}>
          <HomeOptions
            isD2C={false}
            context={uwContext}
            title="Does this look right for the insured's property?"
          />
          <HomeConditions
            isD2C={false}
            context={uwContext}
            title="Do these apply for the insured's home?"
            hideSubmit
          />
          <UnderwritingQuestionsModal
            condition={modalCondition}
            hasAnswerChanged={hasAnswerChanged}
          />
        </Stack>
      )}
    </SectionCard>
  );
}
